import { render, staticRenderFns } from "./JerseyButtonRedLong.vue?vue&type=template&id=0acb7880&scoped=true&"
import script from "./JerseyButtonRedLong.vue?vue&type=script&lang=ts&"
export * from "./JerseyButtonRedLong.vue?vue&type=script&lang=ts&"
import style0 from "./JerseyButtonRedLong.vue?vue&type=style&index=0&id=0acb7880&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0acb7880",
  null
  
)

export default component.exports